import React, { useState, useEffect } from 'react';
import './NewRifa.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewRifa() {
    const [mensaje, setMensaje] = useState('');
    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [numeros, setNumeros] = useState('');
    const [finalizacion, setFinalizacion] = useState('');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [moneda, setMoneda] = useState('');
    const [precio, setPrecio] = useState('');
    const [precioZelle, setPrecioZelle] = useState('');
    const [precioBinance, setPrecioBinance] = useState('');
    const [numeroBendecido1, setNumeroBendecido1] = useState('');
    const [numeroBendecido2, setNumeroBendecido2] = useState('');
    const [numeroBendecido3, setNumeroBendecido3] = useState('');
    const [numeroBendecido4, setNumeroBendecido4] = useState('');
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleImagenChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const previewURL = URL.createObjectURL(file);
            setImagenPreview1(previewURL);
            setIsImage1Selected(true);
        }
    };
    const handleMoneda = (e) => {
        setMoneda(e.target.value);
    };

    const crear = async () => {
        const formData = new FormData();
        const imagenFile = document.getElementById("imagen1").files[0];
        
        if (!imagenFile) {
            toast.error('Por favor, seleccione una imagen.');
            return;
        }
        
        formData.append('imagen1', imagenFile);
        formData.append('nombre', nombre);
        formData.append('descripcion', descripcion);
        formData.append('numeros', numeros);
        formData.append('finalizacion', finalizacion);
        formData.append('moneda', moneda);
        formData.append('precio', precio);
        formData.append('precio_zelle', precioZelle);
        formData.append('precio_binance', precioBinance);
        formData.append('numero_bendecido_1', numeroBendecido1);
        formData.append('numero_bendecido_2', numeroBendecido2);
        formData.append('numero_bendecido_3', numeroBendecido3);
        formData.append('numero_bendecido_4', numeroBendecido4);

        setMensaje('');

        if (!nombre || !numeros || !finalizacion || !moneda || !precio || !precioZelle || !precioBinance) {
            toast.error('Por favor, complete todos los campos obligatorios.');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/rifaPost.php`, {
                method: 'POST',
                body: formData
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                // Limpiar el formulario
                setNombre('');
                setDescripcion('');
                setNumeros('');
                setFinalizacion('');
                setMoneda('');
                setPrecio('');
                setPrecioZelle('');
                setPrecioBinance('');
                setNumeroBendecido1('');
                setNumeroBendecido2('');
                setNumeroBendecido3('');
                setNumeroBendecido4('');
                setImagenPreview1(null);
                setIsImage1Selected(false);
                document.getElementById("imagen1").value = '';
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            setMensaje('');
            toast.error(`Error de conexión: ${error.message}. Por favor, inténtelo de nuevo.`);
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span> +</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Rifa</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <div className='previevImagesLogoBanner'>
                                {isImage1Selected && <img src={imagenPreview1} alt="Vista previa" className='previevImages' />}
                            </div>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Imagen  (obligatorio)</legend>
                                    <input
                                        type="file"
                                        id="imagen1"
                                        accept="image/*"
                                        onChange={handleImagenChange}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nombre  (obligatorio)</legend>
                                    <input
                                        type="text"
                                        required
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset style={{ width: '100%' }}>
                                    <legend>Descripción (opcional)</legend>
                                    <textarea
                                        rows="3"
                                        placeholder="Describe el premio o detalles de la rifa"
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Números  (obligatorio)</legend>
                                    <input
                                        type="number"
                                        required
                                        value={numeros}
                                        onChange={(e) => setNumeros(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha de Finalización  (obligatorio)</legend>
                                    <input
                                        type="datetime-local"
                                        required
                                        value={finalizacion}
                                        onChange={(e) => setFinalizacion(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Moneda (obligatorio)</legend>
                                    <select
                                        id="moneda"
                                        name="moneda"
                                        value={moneda}
                                        onChange={handleMoneda}
                                    >
                                        <option value="">Selecciona una moneda</option>
                                        <option value="$">$</option>
                                        <option value="S/">S/</option>
                                        <option value="€">€</option>
                                        <option value="£">£</option>
                                        <option value="¥">¥</option>
                                        <option value="₹">₹</option>
                                        <option value="₩">₩</option>
                                        <option value="R$">R$</option>
                                        <option value="₽">₽</option>
                                        <option value="฿">฿</option>
                                        <option value="C$">C$</option>
                                        <option value="A$">A$</option>
                                        <option value="₫">₫</option>
                                        <option value="CHF">CHF</option>
                                        <option value="kr">kr</option>
                                        <option value="Bs">Bs</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Pago Móvil (obligatorio)</legend>
                                    <input
                                        type="number"
                                        required
                                        value={precio}
                                        onChange={(e) => setPrecio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Zelle en USD (obligatorio)</legend>
                                    <input
                                        type="number"
                                        required
                                        value={precioZelle}
                                        onChange={(e) => setPrecioZelle(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Binance en USDT (obligatorio)</legend>
                                    <input
                                        type="number"
                                        required
                                        value={precioBinance}
                                        onChange={(e) => setPrecioBinance(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Número Bendecido 1 (opcional)</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: 0001"
                                        value={numeroBendecido1}
                                        onChange={(e) => setNumeroBendecido1(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Número Bendecido 2 (opcional)</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: 0025"
                                        value={numeroBendecido2}
                                        onChange={(e) => setNumeroBendecido2(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Número Bendecido 3 (opcional)</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: 0050"
                                        value={numeroBendecido3}
                                        onChange={(e) => setNumeroBendecido3(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Número Bendecido 4 (opcional)</legend>
                                    <input
                                        type="text"
                                        placeholder="Ej: 0100"
                                        value={numeroBendecido4}
                                        onChange={(e) => setNumeroBendecido4(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
